import { Button, Control, Field, Select } from "@allxsmith/bestax-bulma";
import React from "react";
import LoadingSpinner from "./Spinner";

export function Picker({name, label, value, onChange, options, blank, optionField, disabled, className, inlineEdit=false, onSave, editable, setEditable, secondOptionTitle, additionalOptions=[]}){
    if(!options || !options.results){
        return (
            <LoadingSpinner/>
        )
    }


    return (
      <Field className={inlineEdit ? "has-addons "+className : className}>
          {label && <label className="label">{label}</label>}
          <Control>
              <Select
                  name={name}
                  value={value ? value.id : -1}
                  onChange={onChange}
                  disabled={disabled}
                  className={className}
                  isFocused
              >
                {blank && <option value={"BLANK"} key={-1}></option>}
                  {additionalOptions && additionalOptions.map(option => (<option key={option.id} value={option.id}>{secondOptionTitle ? option[optionField] +" "+option[secondOptionTitle]: option[optionField]}</option>))}
                  {options.results.map(option => (
                      <option key={option.id} value={option.id}>{secondOptionTitle ? option[optionField] +" "+option[secondOptionTitle]: option[optionField]}</option>
                  ))}
              </Select>
          </Control>
          {inlineEdit && editable ? (
              <Control>
                  <Button className={"small-row-white"} color="success" onClick={onSave}>
                      S
                  </Button>
              </Control>
          ) : inlineEdit && (
              <Control>
                  <Button
                      onClick={e => {
                          e.stopPropagation()
                          setEditable(!editable)}
                      }
                      className={"small-row-black"}
                  >
                      E
                  </Button>
              </Control>
          )}
      </Field>
  );
}